module.exports = __webpack_public_path__ + "img/153_thumbnail.e00cf4f4.jpg";